import { jsx as _jsx } from "react/jsx-runtime";
var InfoOutline = function InfoOutline(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.33337 5.33301C7.33337 4.96501 7.63204 4.66634 8.00004 4.66634C8.36804 4.66634 8.66671 4.96501 8.66671 5.33301C8.66671 5.70101 8.36804 5.99967 8.00004 5.99967C7.63204 5.99967 7.33337 5.70101 7.33337 5.33301ZM7.33337 7.33301C7.33337 6.96501 7.63204 6.66634 8.00004 6.66634C8.36804 6.66634 8.66671 6.96501 8.66671 7.33301V10.6663C8.66671 11.0343 8.36804 11.333 8.00004 11.333C7.63204 11.333 7.33337 11.0343 7.33337 10.6663V7.33301ZM8.00004 13.333C5.05937 13.333 2.66671 10.9403 2.66671 7.99967C2.66671 5.05901 5.05937 2.66634 8.00004 2.66634C10.9407 2.66634 13.3334 5.05901 13.3334 7.99967C13.3334 10.9403 10.9407 13.333 8.00004 13.333ZM8.00004 1.33301C4.31804 1.33301 1.33337 4.31767 1.33337 7.99967C1.33337 11.6817 4.31804 14.6663 8.00004 14.6663C11.6814 14.6663 14.6667 11.6817 14.6667 7.99967C14.6667 4.31767 11.6814 1.33301 8.00004 1.33301Z",
      fill: !ignoreColor ? color : undefined
    })
  });
};
export default InfoOutline;